<ng-container *transloco="let t">
  <div class="header-waves-container">
    <div class="header-wrapper">
      <mzic-header></mzic-header>
    </div>
    <div class="waves-section" #wavesCanvas>
      <img
        #heroLogo
        src="/assets/images/logotipo.svg"
        alt="Logotipo"
        class="logotipo" />
    </div>
  </div>

  <div class="about-page">
    <section class="demo">
      <div class="section-container">
        <div class="content left">
          <h3 *ngIf="showMissionTitle" class="content-title">
            {{ t('lang.mission.title') }}
          </h3>
        </div>
        <div class="content right">
          <p class="content-p">
            {{ t('lang.demo.paragraph1') }}
            <br />
            <br />
            {{ t('lang.demo.paragraph2') }}
            <br />
            <br />
            {{ t('lang.demo.paragraph3') }}
            <br />
            <br />
            {{ t('lang.demo.paragraph4') }}
          </p>
        </div>
      </div>
    </section>

    <section class="video">
      <div class="section-container">
        <img
          src="/assets/images/mkt-about-video-sample.png"
          alt="Video Sample" />
      </div>
    </section>

    <section class="big-text">
      <div class="section-container">
        <h2>
          {{ t('lang.bigText.message') }}
        </h2>
      </div>
    </section>

    <section class="culture">
      <div class="section-container">
        <h5 class="mini-title">{{ t('lang.culture.title') }}</h5>
        <div class="boxes-container">
          <div class="box-container">
            <div class="box">
              <div class="icon">
                <mzic-svg
                  src="assets/icons/double-stars.svg"
                  class="w24 purple" />
              </div>
              <h6>{{ t('lang.culture.values.freedom.title') }}</h6>
              <p>
                {{ t('lang.culture.values.freedom.description') }}
              </p>
            </div>
            <div class="box">
              <div class="icon">
                <mzic-svg src="assets/icons/target.svg" class="w24 purple" />
              </div>
              <h6>{{ t('lang.culture.values.excellence.title') }}</h6>
              <p>
                {{ t('lang.culture.values.excellence.description') }}
              </p>
            </div>
            <div class="box">
              <div class="icon">
                <mzic-svg
                  src="assets/icons/up-arrow-curved.svg"
                  class="w24 purple" />
              </div>
              <h6>{{ t('lang.culture.values.learning.title') }}</h6>
              <p>
                {{ t('lang.culture.values.learning.description') }}
              </p>
            </div>
          </div>
          <div class="box-container">
            <div class="box">
              <div class="icon">
                <mzic-svg src="assets/icons/medal.svg" class="w24 purple" />
              </div>
              <h6>{{ t('lang.culture.values.winning.title') }}</h6>
              <p>
                {{ t('lang.culture.values.winning.description') }}
              </p>
            </div>
            <div class="box">
              <div class="icon">
                <mzic-svg
                  src="assets/icons/light-bulb.svg"
                  class="w24 purple" />
              </div>
              <h6>{{ t('lang.culture.values.bestIdea.title') }}</h6>
              <p>
                {{ t('lang.culture.values.bestIdea.description') }}
              </p>
            </div>
            <div class="box">
              <div class="icon">
                <mzic-svg
                  src="assets/icons/up-arrow-curved.svg"
                  class="w24 purple" />
              </div>
              <h6>{{ t('lang.culture.values.music.title') }}</h6>
              <p>
                {{ t('lang.culture.values.music.description') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="download-app">
      <div class="section-container">
        <div class="content left">
          <h4 class="main-title">
            {{ t('lang.downloadApp.title') }}
          </h4>
          <p class="sub-title">
            {{ t('lang.downloadApp.subtitle') }}
          </p>
          <div class="row-stores">
            <div class="stores-icons">
              <a
                href="https://play.google.com/store/apps/details?id=io.mzic.app"
                target="_blank">
                <img
                  src="assets/images/googleplay-logo.svg"
                  alt="Google Play"
                  class="desktop" />
                <img
                  src="assets/images/googleplay-download.svg"
                  alt="Google Play"
                  class="mobile" />
              </a>
              <a
                href="https://apps.apple.com/br/app/mzic/id1670495038"
                target="_blank">
                <img
                  src="assets/images/apple-logo.svg"
                  alt="Apple Logo"
                  class="desktop" />
                <img
                  src="assets/images/appstore-download.svg"
                  alt="Apple Logo"
                  class="mobile" />
              </a>
            </div>
            <div class="qrcode">
              <img
                src="https://mzic-website.s3.us-east-1.amazonaws.com/mzic-default-download-app-url.svg"
                alt="QRCode" />
            </div>
          </div>
        </div>
        <div class="content right">
          <img
            src="assets/images/about-preview-iphone.png"
            alt="Mzic App Preview iPhone"
            class="iphone-preview" />
          <img
            src="assets/images/about-preview-ipad.png"
            alt="Mzic App Preview Ipad"
            class="ipad-preview" />
        </div>
      </div>
    </section>
  </div>

  <mzic-footer class="footer-about"></mzic-footer>
</ng-container>
